import React, { Component } from 'react';
import Layout from "../Layout";

class FormDynamic extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        // Defaults
        const { ...rest } = this.props;
        const title = 'Book a service';
        const text = 'Fill in your details below and we’ll get back to you';

        // Form ID that was passed down
        const { formId } = this.props;

        return (
            <Layout
                title={title}
                text={text}
                {...rest}
            >
            </Layout>
        );
    }
}

export default FormDynamic;
